var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { on: { submit: _vm.submit } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pr-10", attrs: { cols: "12", sm: "12", md: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-0 mt-0" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "label",
                        { staticClass: "font-weight-bold subtitle-1 " },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "view.contract_form.update.steps.office_info"
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "right-button",
                          attrs: { depressed: "", type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.back(1)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "view.contract_form.update.button_caption.fix_button"
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-divider")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.request_email"
                  ),
                  "detail-value": [_vm.formData.officeInfoRequestEmail]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.request_person"
                  ),
                  "detail-value": [
                    _vm.formData.officeInfoRequestPersonLastName +
                      " " +
                      _vm.formData.officeInfoRequestPersonFirstName
                  ]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.request_person_kana"
                  ),
                  "detail-value": [
                    _vm.formData.officeInfoRequestPersonKanaLastName +
                      " " +
                      _vm.formData.officeInfoRequestPersonKanaFirstName
                  ]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.office_no"
                  ),
                  "detail-value": [_vm.formData.officeInfoOfficeNo]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.company_no"
                  ),
                  "detail-value": [_vm.formData.officeInfoCompanyNo]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.corporate_name"
                  ),
                  "detail-value": [_vm.formData.officeInfoCorporateName]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.corporate_address"
                  ),
                  "detail-value": [
                    "〒 " +
                      _vm.formData.officeInfoCorporateZip1 +
                      "-" +
                      _vm.formData.officeInfoCorporateZip2,
                    _vm.formData.officeInfoCorporateAddress1 +
                      " " +
                      _vm.formData.officeInfoCorporateAddress2 +
                      " " +
                      _vm.formData.officeInfoCorporateAddress3
                  ]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.office_name"
                  ),
                  "detail-value": [_vm.formData.officeInfoOfficeName]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.office_name_kana"
                  ),
                  "detail-value": [_vm.formData.officeInfoOfficeNameKana]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.address"
                  ),
                  "detail-value": [
                    "〒 " +
                      _vm.formData.officeInfoZip1 +
                      "-" +
                      _vm.formData.officeInfoZip2,
                    _vm.formData.officeInfoAddress1 +
                      " " +
                      _vm.formData.officeInfoAddress2 +
                      " " +
                      _vm.formData.officeInfoAddress3
                  ]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.tel"
                  ),
                  "detail-value": [_vm.formData.officeInfoTel]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.tantosya"
                  ),
                  "detail-value": [
                    _vm.formData.officeInfoTantosyaLastName +
                      " " +
                      _vm.formData.officeInfoTantosyaFirstName
                  ]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.tantosya_kana"
                  ),
                  "detail-value": [
                    _vm.formData.officeInfoTantosyaKanaLastName +
                      " " +
                      _vm.formData.officeInfoTantosyaKanaFirstName
                  ]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.office_info.tantosya_mail"
                  ),
                  "detail-value": [_vm.formData.officeInfoTantosyaMail]
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pr-10", attrs: { cols: "12", sm: "12", md: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-0 mt-0" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pb-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "label",
                        { staticClass: "font-weight-bold subtitle-1 " },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "view.contract_form.update.steps.apply_info"
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "right-button",
                          attrs: { depressed: "", type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.back(2)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "view.contract_form.update.button_caption.fix_button"
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-divider")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.apply_info.apply_date"
                  ),
                  "detail-value": [_vm.getApplyDate()]
                }
              }),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(0)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.kino_kunren"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getKobetuPlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.apply_capacity"
                        ),
                        "detail-value": [_vm.formData.applyInfoApplyCapacity]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoKinoKunrenStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _vm.isShowKobetuPlanPeriod()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.apply_info.plan_period"
                            ),
                            "detail-value": [_vm.getKobetuPlanPeriod()]
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKobetuPrice()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.apply_info.price"
                            ),
                            "detail-value": [_vm.getKobetuPrice()]
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKobetuTokubetuDetail()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.contract.tokubetu_detail"
                            ),
                            "detail-value": _vm.getKobetuBiko(),
                            "is-html": true
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(1)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: "subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.oral_care"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getOralCarePlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoOralCareSstartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _vm.isShowOralCarePlanPeriod()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.apply_info.plan_period"
                            ),
                            "detail-value": [_vm.getOralCarePlanPeriod()]
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowOralCarePrice()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.apply_info.price"
                            ),
                            "detail-value": [_vm.getOralCarePrice()]
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowOralCareTokubetuDetail()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.contract.tokubetu_detail"
                            ),
                            "detail-value": _vm.getOralCareBiko(),
                            "is-html": true
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(2)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.basic"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getBasicPlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.apply_capacity"
                        ),
                        "detail-value": [
                          _vm.formData.applyInfoApplyCapacityBasic
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoBasicStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.plan_period"
                        ),
                        "detail-value": [_vm.getBasicPlanPeriod()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.price"
                        ),
                        "detail-value": [_vm.getBasicPrice()]
                      }
                    }),
                    _vm._v(" "),
                    _vm.isShowKobetuTokubetuDetail()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.contract.tokubetu_detail"
                            ),
                            "detail-value": _vm.getBasicBiko(),
                            "is-html": true
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(8)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.entry"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getEntryPlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoEntryStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.plan_period"
                        ),
                        "detail-value": [_vm.getEntryPlanPeriod()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.price"
                        ),
                        "detail-value": [_vm.getEntryPrice()]
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(7)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.old_standard"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getOldStandardPlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.apply_capacity"
                        ),
                        "detail-value": [
                          _vm.formData.applyInfoApplyCapacityOldStandard
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoOldStandardStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.plan_period"
                        ),
                        "detail-value": [_vm.getOldStandardPlanPeriod()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.price"
                        ),
                        "detail-value": [_vm.getOldStandardPrice()]
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(9)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.medium"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getMediumPlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.apply_capacity"
                        ),
                        "detail-value": [
                          _vm.formData.applyInfoApplyCapacityMedium
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoMediumStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.plan_period"
                        ),
                        "detail-value": [_vm.getMediumPlanPeriod()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.price"
                        ),
                        "detail-value": [_vm.getMediumPrice()]
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(3)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.standard"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getStandardPlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.apply_capacity"
                        ),
                        "detail-value": [
                          _vm.formData.applyInfoApplyCapacityStandard
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoStandardStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.plan_period"
                        ),
                        "detail-value": [_vm.getStandardPlanPeriod()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.price"
                        ),
                        "detail-value": [_vm.getStandardPrice()]
                      }
                    }),
                    _vm._v(" "),
                    _vm.isShowKobetuTokubetuDetail()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.contract.tokubetu_detail"
                            ),
                            "detail-value": _vm.getStandardBiko(),
                            "is-html": true
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(10)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.professional"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getProfessionalPlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.apply_capacity"
                        ),
                        "detail-value": [
                          _vm.formData.applyInfoApplyCapacityProfessional
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoProfessionalStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.plan_period"
                        ),
                        "detail-value": [_vm.getProfessionalPlanPeriod()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.price"
                        ),
                        "detail-value": [_vm.getProfessionalPrice()]
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(11)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.upgrade"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.current_plan"
                        ),
                        "detail-value": [
                          _vm.isShowToUpgradeLimitedPreviousPlanName()
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.upgrade_plan"
                        ),
                        "detail-value": [
                          _vm.isShowToUpgradeLimitedAfterPlanName()
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.apply_capacity"
                        ),
                        "detail-value": [_vm.formData.toUpgradeCapacity]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [_vm.formData.toUpradePlanPeriodStr]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.price"
                        ),
                        "detail-value": [_vm.getUpgradePrice()]
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(6)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.motion_ai"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getMotionAiPlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoMotionAiStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.plan_period"
                        ),
                        "detail-value": [_vm.getMotionAiPlanPeriod()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.price"
                        ),
                        "detail-value": [_vm.getMotionAiPrice()]
                      }
                    }),
                    _vm._v(" "),
                    _vm.isShowKobetuTokubetuDetail()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.contract.tokubetu_detail"
                            ),
                            "detail-value": _vm.getMotionAiBiko(),
                            "is-html": true
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(4)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.upgrade_to_standard"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [_vm.getUpgradeToStandardPlanName()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoStandardStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.plan_period"
                        ),
                        "detail-value": [_vm.getStandardPlanPeriod()]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.price"
                        ),
                        "detail-value": [_vm.getStandardPrice()]
                      }
                    }),
                    _vm._v(" "),
                    _vm.isShowKobetuTokubetuDetail()
                      ? _c("detail-data-single-label", {
                          attrs: {
                            "detail-label": _vm.$t(
                              "view.contract_form.update.label.contract.tokubetu_detail"
                            ),
                            "detail-value": _vm.getUpgradeToStandardBiko(),
                            "is-html": true
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.applyInfoApplyService.includes(5)
                ? [
                    _c(
                      "v-row",
                      { staticClass: "pt-0 mt-0 " },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pb-0", attrs: { cols: "12" } },
                          [
                            _c("label", { staticClass: " subtitle-2 " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.label.apply_info.additional_tablet"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.period"
                        ),
                        "detail-value": [
                          _vm.$t(
                            "view.contract_form.update.label.fixed_text.additional_tablet_plan_name"
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.start_date"
                        ),
                        "detail-value": [
                          _vm.parseDateToNengetu(
                            _vm.formData.applyInfoAdditionalTabletStartDate
                          )
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("detail-data-single-label", {
                      attrs: {
                        "detail-label": _vm.$t(
                          "view.contract_form.update.label.apply_info.plan_period"
                        ),
                        "detail-value": [_vm.getAdditionalTabletPlanPeriod()]
                      }
                    }),
                    _vm._v(" "),
                    [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pt-1 pb-1 pl-3 justify-center",
                                  attrs: {
                                    height: "100%",
                                    outlined: "",
                                    tile: ""
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "detail-data--label" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("お申し込みタブレット合計金額")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "8" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pt-1 pb-1 pl-3",
                                  attrs: { outlined: "", tile: "" }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mb-0 mt-0 pt-2 pb-0",
                                      attrs: { cols: "12", sm: "12", md: "12" }
                                    },
                                    [
                                      _c("v-data-table", {
                                        attrs: {
                                          hover: true,
                                          "hide-default-footer": "",
                                          "disable-sort": "",
                                          headers: _vm.tabletHeaders,
                                          items: _vm.tabletItems
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item",
                                              fn: function(ref) {
                                                var item = ref.item
                                                return [
                                                  _c("tr", [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formData
                                                            .displayDataTableObj[
                                                            "rehabCloudTabletInitialFeeText"
                                                          ]
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "¥" +
                                                            _vm.formData.displayDataTableObj[
                                                              "rehabCloudTabletInitialFeeMonthly"
                                                            ].toLocaleString()
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formData
                                                            .additionalTablets
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "¥" +
                                                            _vm.formData.displayDataTableObj[
                                                              "initialFeeTotalPrice"
                                                            ].toLocaleString() +
                                                            "（初月のみ）"
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("tr", [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formData
                                                            .displayDataTableObj[
                                                            "rehabCloudTabletText"
                                                          ]
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "¥" +
                                                            _vm.formData.displayDataTableObj[
                                                              "rehabCloudTabletMonthly"
                                                            ].toLocaleString()
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formData
                                                            .additionalTablets
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "¥" +
                                                            _vm.formData.displayDataTableObj[
                                                              "tabletsTotalPrice"
                                                            ].toLocaleString()
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1333255448
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pr-10", attrs: { cols: "12", sm: "12", md: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-0 mt-0" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "label",
                        { staticClass: "font-weight-bold subtitle-1 " },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "view.contract_form.update.steps.request_info"
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isShowRequestInfoFixBtn()
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "right-button",
                              attrs: { depressed: "", type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.back(3)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.button_caption.fix_button"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-divider")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.request_info.company_name"
                  ),
                  "detail-value": [_vm.formData.requestInfoCompanyName]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.request_info.office_name"
                  ),
                  "detail-value": [_vm.formData.requestInfoOfficeName]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.request_info.address"
                  ),
                  "detail-value": [
                    "〒 " +
                      _vm.formData.requestInfoZip1 +
                      "-" +
                      _vm.formData.requestInfoZip2,
                    _vm.formData.requestInfoAddress1 +
                      " " +
                      _vm.formData.requestInfoAddress2 +
                      " " +
                      _vm.formData.requestInfoAddress3
                  ]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.request_info.tel"
                  ),
                  "detail-value": [_vm.formData.requestInfoTel]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.request_info.request_person"
                  ),
                  "detail-value": [
                    _vm.formData.requestInfoRequestPersonLastName +
                      " " +
                      _vm.formData.requestInfoRequestPersonFirstName
                  ]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.request_info.request_email"
                  ),
                  "detail-value": [_vm.formData.requestInfoRequestEmail]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.request_info.how_to_request"
                  ),
                  "detail-value": [_vm.formData.requestInfoHowToRequest]
                }
              }),
              _vm._v(" "),
              _c("detail-data-single-label", {
                attrs: {
                  "detail-label": _vm.$t(
                    "view.contract_form.update.label.request_info.how_to_send"
                  ),
                  "detail-value": [_vm.formData.requestInfoHowToSend]
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      (_vm.isEkycMainPlan() && !_vm.isPersonalEkycSkip()) ||
      _vm.formData.applyInfoApplyService.includes(5)
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "pr-10",
                  attrs: { cols: "12", sm: "12", md: "12" }
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-0 mt-0" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "label",
                            { staticClass: "font-weight-bold subtitle-1 " },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.steps.shipping_address_info"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "right-button",
                              attrs: { depressed: "", type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.back(4)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.button_caption.fix_button"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-divider")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("detail-data-single-label", {
                    attrs: {
                      "detail-label": _vm.$t(
                        "view.contract_form.update.label.shipping_address_info.company_name"
                      ),
                      "detail-value": [
                        _vm.formData.shippingAddressInfoCompanyName
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("detail-data-single-label", {
                    attrs: {
                      "detail-label": _vm.$t(
                        "view.contract_form.update.label.shipping_address_info.office_name"
                      ),
                      "detail-value": [
                        _vm.formData.shippingAddressInfoOfficeName
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("detail-data-single-label", {
                    attrs: {
                      "detail-label": _vm.$t(
                        "view.contract_form.update.label.shipping_address_info.address"
                      ),
                      "detail-value": [
                        "〒 " +
                          _vm.formData.shippingAddressInfoZip1 +
                          "-" +
                          _vm.formData.shippingAddressInfoZip2,
                        _vm.formData.shippingAddressInfoAddress1 +
                          " " +
                          _vm.formData.shippingAddressInfoAddress2 +
                          " " +
                          _vm.formData.shippingAddressInfoAddress3
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("detail-data-single-label", {
                    attrs: {
                      "detail-label": _vm.$t(
                        "view.contract_form.update.label.shipping_address_info.tel"
                      ),
                      "detail-value": [_vm.formData.shippingAddressInfoTel]
                    }
                  }),
                  _vm._v(" "),
                  _c("detail-data-single-label", {
                    attrs: {
                      "detail-label": _vm.$t(
                        "view.contract_form.update.label.shipping_address_info.request_person"
                      ),
                      "detail-value": [
                        _vm.formData.shippingAddressInfoPersonLastName +
                          " " +
                          _vm.formData.shippingAddressInfoPersonFirstName
                      ]
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "pb-0 mb-0", attrs: { justify: "space-around" } },
        [
          _vm.isEkycMainPlan() || _vm.formData.applyInfoApplyService.includes(5)
            ? _c(
                "v-col",
                {
                  staticClass: "mb-0 mt-0 pt-3 pb-0 text-center",
                  attrs: { cols: "11", sm: "11" }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: _vm.$t("view.link.rehab_cloud_policy.href")
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("view.link.rehab_cloud_policy.text"))
                      )
                    ]
                  ),
                  _vm._v("\n            ・\n            "),
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: _vm.$t("view.link.rehab_cloud_tablet_policy.href")
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("view.link.rehab_cloud_tablet_policy.text")
                        )
                      )
                    ]
                  ),
                  _vm._v("\n            ・\n            "),
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: _vm.$t("view.link.privacy.href")
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("view.link.privacy.text")))]
                  ),
                  _vm._v("\n            ・\n            "),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: _vm.$t(
                          "view.link.service_usage_compliance_document.href"
                        )
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "view.link.service_usage_compliance_document.text"
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("br")
                ]
              )
            : _c(
                "v-col",
                {
                  staticClass: "mb-0 mt-0 pt-3 pb-0 text-center",
                  attrs: { cols: "11", sm: "11" }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: _vm.$t("view.link.rehab_cloud_policy.href")
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("view.link.rehab_cloud_policy.text"))
                      )
                    ]
                  ),
                  _vm._v("\n            ・\n            "),
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: _vm.$t("view.link.privacy.href")
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("view.link.privacy.text")))]
                  ),
                  _c("br"),
                  _vm._v("\n            ・\n            "),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: _vm.$t(
                          "view.link.service_usage_compliance_document.href"
                        )
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "view.link.service_usage_compliance_document.text"
                          )
                        )
                      )
                    ]
                  ),
                  _c("br")
                ]
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { justify: "space-around" } },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 text-center",
              attrs: { cols: "12", sm: "6", md: "4" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    depressed: "",
                    block: "",
                    type: "submit",
                    color: "#11479B",
                    dark: true
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "view.contract_form.update.button_caption.request"
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c57a582", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c57a582","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contract_form/Confirm.vue
// module id = IuMu
// module chunks = 1